import axios from "@axios";


export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {

      return state.items.map((item) => ({
        label: item.description + ` (${item.acronym})`,
        value: item.type,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {

    //getAll Retrieves all rules for the grid table view.
    async getAll({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_ALARMS_MS_URL}/v2/category/getAll`);

      if (!data) {
        return [];
      }

      commit("setData", data);
      return data;
    },
    

    //clear Clears the stored list of rules in the state.
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
